<div class="resource-carousel">
  <swiper-container [config]="config" luiSwiper init="false">
    <swiper-slide *ngFor="let slide of slides">
      <ng-template [ngTemplateOutlet]="slide.template"></ng-template>
    </swiper-slide>
  </swiper-container>
  <div class="resource-carousel-navigation">
    <button luiFab size="lg" class="prev">
      <mat-icon svgIcon="chevron_left_thin"></mat-icon>
    </button>
    <button luiFab size="lg" class="next">
      <mat-icon svgIcon="chevron_right_thin"></mat-icon>
    </button>
  </div>
</div>
